import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux"; 
import { Tabs } from "antd";
import BreadCrumb from "../../../../layout/BreadCrumb";  
import Documents from "./documents/Documents";
import { setRefetch, setRefetchKey } from "../../../../features/global/globalSlice";
import DocImages from "./document-image/DocImages";
import DocumentsGeo from "./documents-geo/DocumentsGeo";

function NonSpatialViewList() {
  const dispatch = useDispatch();
  const [active, setactive] = useState("1"); 
  const {iwuaObj} = useSelector((state)=>state.obj)
  const [showVerify, setShowVerify] = useState(false);
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["schemes"],
  }));
  async function refetching(activeKey) {
    setShowVerify(false)
    setactive(activeKey);
    await dispatch(setRefetch());
    await dispatch(setRefetchKey(activeKey));
  }



  const tabConfigurations = [
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Documents</span>
        </span>
      ),
      key: "1",
      children: <Documents />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className=" " >Images</span>
        </span>
      ),
      key: "2",
      children:  <DocImages  /> 
    },
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Maps and Geo Info</span>
        </span>
      ),
      key: "3",
      children: <DocumentsGeo/>,
    }, 
  ];
  return (
    <>
   <BreadCrumb
           breadcrumbs={[
             { title: "Schemes Overview", path: "/scheme/scheme-overview" },
             { title: "Public", path: "/scheme/public-scheme" },
             { title: "Public View", path: "/scheme/public-scheme-view" },
             { title: `View ${activeObjSchemes?.schName}` }
           ]}
         />
      
      <div className="white_card mt-[2.41rem] flex-1 min-h-[80vh]">
        <div className="form-add-h">{iwuaObj?.instName} IWUA</div>
        <Tabs
          items={tabConfigurations}
          defaultActiveKey="1"
          activeKey={active}
          onChange={refetching}
          className="mt-[1.75rem] iwua-tab-holder  iwua-tabs-btn iwua-tabs-btn-inactive iwua-ink-bar iwua-nav-list "
        />
      </div>
    </>
  );
}

export default NonSpatialViewList;
